import { ApiQueryParams } from '@frontend/api-utils';
import { AsyncSelectInputV2 } from '@frontend/components/basic-forms';
import React from 'react';

import useObjectSelectInput from './object-select-input.controller';
import { ObjectSelectInputProps } from './object-select-input.types';

export type { ObjectSelectInputProps, UrlParams } from './object-select-input.types';

const ID = 'object-select-input';

/**
 * @todo add generic create object
 * @param props
 * @returns
 */
export const ObjectSelectInput = <T extends { id: string }, D extends string | number>(props: ObjectSelectInputProps<T, D>) => {
    const viewProps = useObjectSelectInput<T, D>(props);
    if (viewProps.hide) return <></>;
    return (
        <AsyncSelectInputV2
            {...props}
            id={props.id || ID}
            label={props.label}
            className={props.className}
            helpMessage={props.helpMessage}
            options={viewProps.options}
            onSelect={viewProps.onSelect}
            value={viewProps.value?.id ?? props.idValue}
            searchValueOverwrite={props.searchValueOverwrite}
            onScrollToBottom={viewProps.onScrollToBottom}
            onSearch={viewProps.search}
            isClearable={viewProps.isClearable}
            required={props.required}
            disabled={viewProps.overwriteDisabled || props.disabled}
            onFocus={props.onFocus}
            onBlur={props.onBlur}
            isOpenOverwrite={viewProps.isOpenOverwrite ?? props.isOpenOverwrite}
        />
    );
};

export default ObjectSelectInput;

export interface ObjectSelectProps<T extends { id: string }, D extends string | number> {
    id?: string;
    label?: React.ReactNode;
    required?: boolean;
    submitted?: boolean;
    onChange?: (newValue: string | null) => void;
    onChangeObject?: (newValue: T | null) => void;
    value?: string | null;
    className?: string;
    disabled?: boolean;
    useConditionedStyling?: boolean;
    isClearable?: boolean;
    createEnabled?: boolean;
    queryParams?: ApiQueryParams<D>;
    disableFetch?: boolean;
    hidden?: boolean;
    allowURLChange?: boolean;
    hideLabel?: boolean;
    searchValueOverwrite?: string;
    minSearchCharacters?: number;
    subset?: string[];
    onFocus?: React.FocusEventHandler<HTMLInputElement> | undefined;
    onBlur?: React.FocusEventHandler<HTMLInputElement> | undefined;
    isOpenOverwrite?: boolean;
    hideOnOneOption?: boolean;
    helpMessage?: React.ReactNode;
    /** URL query param name when allowURLChange is enabled; defaults to component id or entity-specific fallback */
    queryKeyOverride?: string;
    customLabel?: (object: T) => string;
    overWriteLabel?: (obj: T) => string;
    customLabelAction?: React.ReactNode;
}
